import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { ParkingService } from '../lib/parking.service'

const GET_TARIFFS = 'get-tariffs'

export const useTariffs = () => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  return useQuery({
    queryKey: [GET_TARIFFS, projectId],
    queryFn: () => ParkingService.getTariffs(projectId),
    select: data => data.data,
    staleTime: 0
  })
}
